import { NgModule } from '@angular/core';
import { ImageCropperComponent } from 'ngx-image-cropper';

@NgModule({
  imports: [ImageCropperComponent],  // ✅ since it's standalone, you import it here
  exports: [ImageCropperComponent],  // ✅ re-export for other module-based components
})
export class ImageCropperWrapperModule {}